import { QuestionTypeEnum } from '@propertelligent/client-api';
import React, { useEffect, useState } from 'react'
import { Badge } from 'react-bootstrap';
import EmptyData from '../../common/EmptyData';
import { TextCss } from '../../GlobalCss/TextCss';
import { Text } from 'recharts';
import { Background } from '../../GlobalCss/Background';

const QuestionnairesInfo = ({ leaseApplicationData, templateData, leaseApplication }) => {
  const [processedData, setProcessedData] = useState([]);

  // Function to process questionnaires
  const processQuestionnaires = () => {

    if (leaseApplicationData?.length) {
      return leaseApplicationData?.map(response => {
        const question = templateData?.find(q => q.id === response?.questionId);
        if (!question) return null;
        const selectedOptions = response?.selectedOptionIds?.map(optionId => {
          const option = question?.choices?.find(choice => choice.id === optionId);
          return option ? option.optionText : null;
        }).filter(Boolean);
        let displayText = '';
        let followUpText = '';
        switch (question.questionTypeId) {
          case 1: displayText = question.questionText;
            if (response.selectedOptionIds.includes(question.followUpQuestionChoiceId)) {
              followUpText = question.followUpQuestionText;
            }
            break;
          case 2:
          case 3:
          case 4:
          default:
            displayText = question.questionText;
        }
        return {
          questionTypeId: question.questionTypeId,
          questionText: displayText,
          selectedOptions: selectedOptions,
          followUpQuestion: followUpText,
          followUpAnswer: response?.followUpAnswer,
          answerText: response?.answer
        };
      }).filter(Boolean);
    }


    return [];
  };
  useEffect(() => {
    if (leaseApplicationData) {
      try {
        const data = processQuestionnaires();
        setProcessedData(data);
      } catch (error) {
        console.error('Error processing questionnaires:', error);
      }
    }
  }, [leaseApplicationData, templateData]);
  const renderQuestionContent = (item) => {
    switch (item.questionTypeId) {
      case 1:
        return (
          <>
            <div className="question-row">
              <p className={TextCss.black.sub_heading_600_14}>{item?.questionText}</p>
              <p className="d-flex gap-1">
                {item?.selectedOptions ? (
                  item?.selectedOptions?.map((option, idx) => (
                     <div className={Background.LightBlue.Square.square40} key={idx}> {option} </div>
                  ))
                ) : (item?.choices?.map((choice) => (
                   <div className={Background.LightBlue.Square.square40} key={choice.id || choice?.optionText}> {choice?.optionText} </div>
                ))
                )}
              </p>
            </div>
            <p className={TextCss.black.sub_heading_600_14}>{item?.followUpQuestion}</p>
            {(item?.followUpQuestion && item?.followUpAnswer) && (
              <div className="BackgroundlightRed py-3 my-2 px-2 rounded-1 answer-box ">
                  <p className={TextCss.black.normal_text_400_14}>
                    {item.followUpAnswer}
                  </p>
                
              </div>
            )}

          </>
        );

      case 2:
        return (
          <div className="question-row">
            <p className={TextCss.black.sub_heading_600_14}>{item.questionText}</p>
            <p className="d-flex gap-1">
              {item.selectedOptions ? (item.selectedOptions.map((option, idx) => ( <div className={Background.LightBlue.Square.square40} key={idx} > {option} </div>))
              ) : (item.choices?.map((choice) => (
                <div className={Background.LightBlue.Square.square40}
                  key={choice.id || choice.optionText}
                  // bg="primary"
                >
                  {choice.optionText}
                </div>
              ))
              )}
            </p>
          </div>
        );
      case 3:
      case 4:
        return (
          <div className="answer">
            <p className={TextCss.black.sub_heading_600_14}>{item.questionText}</p>
            {item.answerText && (
              <p className="normal_text italic">{item.answerText}</p>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <> {leaseApplicationData?.length ? (
      <div className="application-card">
        <div className="question-list">
          {leaseApplication ? (processedData?.map((item, index) => (<div key={index}>{renderQuestionContent(item)}</div>))
          ) : (
            leaseApplicationData?.map((item, index) => (
              <div key={index} className=''>
                {item?.questionTypeId === QuestionTypeEnum.SingleChoice ||
                  item?.questionTypeId === QuestionTypeEnum.MultipleChoice ? (
                  <>
                    <div className="question-row">
                      <p className={TextCss.black.sub_heading_600_14}>{item?.questionText}</p>
                      <p className="d-flex gap-1">
                        {item?.choices?.map((subItem) => (
                          <React.Fragment key={subItem?.id || subItem?.optionText}>
                            {!leaseApplication ? ( <div className={Background.LightBlue.Square.square40}>{subItem?.optionText}</div>
                            ) : (subItem?.isRadio &&  <div className={Background.LightBlue.Square.square40}>{subItem?.optionText}</div>)}
                          </React.Fragment>
                        ))}
                      </p>

                    </div>
                    <p>{item.followUpQuestionText}</p>
                    {(item.followUpQuestionText) && (
                      <div className="BackgroundlightRed py-3 my-3 px-2 answer-box rounded-1">
                        <p className="normal_text fw-bold black">
                          Additional Details:
                          <span className="normal_text fw-400 px-2">
                            <i>"Have you ever been evicted from your residence in the past</i>
                          </span>
                        </p>
                      </div>
                    )}
                  </>
                ) : item?.questionTypeId === QuestionTypeEnum.ShortAnswer ? (
                  <div className="answer">
                    <p className="normal_text black fw-500 py-2">{item?.questionText}</p>
                    <p className="normal_text">{item?.shortAnswer}</p>
                  </div>
                ) : item?.questionTypeId === QuestionTypeEnum.Paragraph ? (
                  <div className="answer">
                    <p className="normal_text black fw-500 py-2">{item?.questionText}</p>
                    <p className="normal_text italic">{item?.paragraph}</p>
                  </div>
                ) : null}
              </div>
            ))
          )}
        </div>
      </div>) : (<EmptyData mainText="Data not found" />)}
    </>)
}

export default QuestionnairesInfo